import * as domtoimage from './dom-to-image';
import * as MegaPixImage from './megapix-image';
import * as numeric from './numeric';
import { getHoughPoints } from './hough';
import { importWithRetry } from './importWithRetry';
import { canvasToJpegDataUrl } from './fileUtils';

/* eslint-disable */
const scanUtils = function ScanUtils() {
  let cssMode = false;
  let self = this;

  let previewConainerId = '';
  let previewContainer = null;

  let resultConainerId = '';
  let resultConainer = null;

  let cvDoneCallBack = null;

  let width = 0;
  let height = 0;

  let varianceNormalized = 0;
  let averageBrightness = 0;

  let previewImageId = '';
  let previewImage = '';
  let previewOverlayId = '';
  let previewOverlay = '';
  let previewSpinner = null;
  let imageOffsetLeft = 0;

  let zoom = null;
  let zoomSize = 150;

  let cropperId = '';
  let cropper = null;
  let cropPointSize = 40;

  let cropLeftTop = null;
  let cropRightTop = null;
  let cropLeftBot = null;
  let cropRightBot = null;

  let cropLeft = null;
  let cropRight = null;
  let cropTop = null;
  let cropBot = null;

  let activeCropItem = null;
  let activeCropping = false;

  let resultOutputId = '';
  let resultOutput = '';
  let canvasfx = null;

  let lastShotCanvas = null;
  let lastLoadedFileTime = null;
  let detectCanvas = null;
  let lastDetectedPoints = null;
  let lastDetectedPointsFailed = false;
  let scaledDetectedPoints = null;
  let scaledUserPoints = null;

  let resultURI = '';
  let cropResultImageContainer = null;
  let cropResultImageWarapper = null;
  let cropCanvas = null;

  let lastCropAreaPercents = 0;

  let maxResultSizeCSS = 2000;
  let maxResultSize = 1700;
  let maxPreviewSize = 1000;
  let detectSize = 300;
  let resultQuality = 0.7;
  let minResultSize = 500;
  let minResultPhotoSize = 2000;
  let lastCropSize;

  let loadFile = null;

  let isMobileBrowser = false;

  let showSpinnerOnProcessingImage = true;

  let osVersion = false;

  let lastUsedResolution = null;
  let lastUsedResolutionFront = null;

  /*/let onFindPointsComplete = null;
  let onImageLoadComplete = null;
  let onImagePreviewComplete = null;
  let onImageResizeComplete = null;
  let onImageLoadStart = null;
  let onMultyUploadDone = null;
  let onPDFLoadStart = null;
  let onPDFLoaded = null;

  let allowMultyFies = false;*/

  let rectOptions = {
    opacity: 0.5,
    fillColor: '#14a130',
    strokeColor: '#11ff0d',
    strokeWidth: 2
  };

  let debug;
  let utilsId = null;
  this.setUtilsId = id => {
    utilsId = id;
  };

  this.showSpinner = function() {
    previewSpinner.style.display = 'flex';
  };

  this.hideSpinner = function() {
    previewSpinner.style.display = 'none';
  };

  this.setShowSpinnerOnProcessingImage = function(as) {
    showSpinnerOnProcessingImage = as;
  };

  this.setCSSMode = function() {
    maxResultSize = maxResultSizeCSS;
    cssMode = true;
  };

  this.setOsVersion = function(version) {
    osVersion = version;
  };

  this.setAllowMultyFiles = function(as) {
    this.allowMultyFies = as;
    if (as) {
      loadFile.setAttribute('multiple', '');
    } else {
      loadFile.removeAttribute('multiple');
    }
  };

  this.hideCrop = function() {
    previewOverlay.style.display = 'none';
    cropper.style.display = 'none';
  };

  this.showCrop = function() {
    previewOverlay.style.display = 'block';
    cropper.style.display = 'block';
  };

  this.prepareScanUtils = function() {
    if (!window.scanUtilsIsReady) {
      if (window.isChrome) {
        window.utils.setCSSMode(); // Android Modus
      }
      window.utils.setOsVersion(window.iosVersion);
      window.utils.initScan(() => {});
      window.scanUtilsIsReady = true;
      window.utils.createPreview();
    }
  };
  /**
   * Init Utils.
   *
   * @param scannerReadyCallback - callback function after OpenCV is ready.
   */
  this.initScan = function(scannerReadyCallback) {
    cvDoneCallBack = scannerReadyCallback;

    let padding = cropPointSize + 10;
    let size = cropPointSize / 2;

    let cssRules =
      '.cropPoint.active{background-color:rgb(103, 255, 0)}.cropPoint{z-index: 101;outline:none !important;border-radius:50%;touch-action:none;user-select:none;position:absolute;width:' +
      size +
      'px;height:' +
      size +
      'px;background-color:rgb(0, 255, 84);border:' +
      padding +
      'px solid rgba(255,255,255,.0);top:0;left:0;opacity:.6;-moz-background-clip:border;-webkit-background-clip:border;background-clip:border-box;-moz-background-clip:padding;-webkit-background-clip:padding;background-clip:padding-box;-moz-background-clip:content;-webkit-background-clip:content;background-clip:content-box;-ms-touch-action: manipulation;touch-action: manipulation;}';
    cssRules +=
      ' .cropPointVertical{z-index: 100;width: 12px;height: 35px;border-width: 30px;border-radius: 70px;}';
    cssRules +=
      ' .cropPointHorisontal{z-index: 100;width: 35px;height: 12px;border-width: 30px;border-radius: 70px;}';

    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(cssRules));
    document.getElementsByTagName('head')[0].appendChild(styleElement);

    previewSpinner = document.createElement('div');
    //previewSpinner.innerHTML = '<div class="sk-cube-grid"> <div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div><div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>';

    if (!cssMode) {
      // noinspection CheckTagEmptyBody,CheckTagEmptyBody
      previewSpinner.innerHTML =
        '<div class="ocrloader"> <em></em> <div> <i></i><i></i><i></i><i></i><i></i><i></i><i></i> <i></i><i></i><i></i><i></i><i></i><i></i><i></i> <i></i><i></i><i></i> </div><span></span></div>';
      previewSpinner.style =
        'display: none; align-content: center; width: 100%; position: fixed; left: 0; top: 0; bottom: 0;  z-index: 9999;background-color:rgba(0, 0, 0, 0.3);';
    } else {
      previewSpinner.innerHTML = '<div class="ios-spinner"></div>';
      previewSpinner.style =
        "display: none; align-content: center; width: 100%; position: fixed; left: 0; top: 0; bottom: 0;  z-index: 20000;background-color:rgba(0, 0, 0, 0.3);background-image: url('loader.gif'); background-repeat: no-repeat;background-position: center;";
    }
    loadFile = document.createElement('input');
    loadFile.setAttribute('type', 'file');
    loadFile.setAttribute('id', 'LOAD_DOCUMENT_IMAGE');
    //loadFile.setAttribute("accept", "image/jpeg,image/gif,image/png,image/tiff,application/pdf,.gif,.jpeg,.jpg,.pdf,.png,.tiff,.gif");
    loadFile.setAttribute('accept', '.gif,.jpeg,.jpg,.pdf,.png');
    //loadFile.setAttribute("capture", "camera");
    loadFile.style.display = 'none';

    self.addFileInputHandler(loadFile);
    document.body.appendChild(previewSpinner);
    document.body.appendChild(loadFile);
    isMobileBrowser = self.mobileAndTabletcheck();
  };

  this.setLoadCameraMode = function() {
    loadFile.setAttribute('capture', 'environment');
    loadFile.setAttribute('accept', 'image/*');
  };

  this.setLoadFileMode = function() {
    loadFile.removeAttribute('capture');
    //loadFile.setAttribute("accept", "image/jpeg,image/gif,image/png,image/tiff,application/pdf,.gif,.jpeg,.jpg,.pdf,.png,.tiff,.gif");
    loadFile.setAttribute('accept', '.gif,.jpeg,.jpg,.pdf,.png');
  };

  this.resetImageProcessingEvents = function() {
    this.onFindPointsComplete = null;
    this.onImagePreviewComplete = null;
    this.onMultyUploadDone = null;
    this.onPDFLoadStart = null;
    this.onPDFLoaded = null;
    this.onImageResizeComplete = null;
    this.onImageLoadStart = null;
  };

  this.setOnFindPointsComplete = function(onFindPointsComplete) {
    this.onFindPointsComplete = onFindPointsComplete;
  };

  this.setOnImagePreviewComplete = function(onImagePreviewComplete) {
    this.onImagePreviewComplete = onImagePreviewComplete;
  };

  this.setOnImageLoadComplete = function(onImageLoadComplete) {
    this.onImageLoadComplete = onImageLoadComplete;
  };

  this.setOnMultyUploadDone = function(onMultyUploadDone) {
    this.onMultyUploadDone = onMultyUploadDone;
  };

  this.setOnPDFLoadStart = function(onPDFLoadStart) {
    this.onPDFLoadStart = onPDFLoadStart;
  };

  this.setOnPDFLoaded = function(onPDFLoaded) {
    this.onPDFLoaded = onPDFLoaded;
  };

  this.setOnImageResizeComplete = function(onImageResizeComplete) {
    this.onImageResizeComplete = onImageResizeComplete;
  };

  this.setOnImageLoadStart = function(onImageLoadStart) {
    this.onImageLoadStart = onImageLoadStart;
  };

  this.getLastCropAreaPercents = function() {
    return lastCropAreaPercents;
  };

  this.isLastCropTooSmall = function(minSize) {
    return lastCropSize < (minSize ? minSize : minResultSize);
  };

  this.isLastDetectedPointsFailed = function() {
    return lastDetectedPointsFailed;
  };

  this.getLastDetectedPoints = function() {
    return lastDetectedPoints;
  };

  this.getLastImageWidth = function() {
    return lastShotCanvas.width;
  };

  this.getLastImageHeight = function() {
    return lastShotCanvas.height;
  };

  this.isLastImageNotOld = function() {
    return lastLoadedFileTime < 3000;
  };

  /**
   * Create view for image preview and crop-edit function.
   *
   * @param containerId - div for view
   * @param maxHeight
   */
  this.createPreview = function(containerId, maxHeight) {
    if ((previewConainerId = containerId)) {
      previewContainer = document.getElementById(previewConainerId);
    }

    previewImageId = 'outputImage';
    previewImage = document.createElement('img');
    previewImage.setAttribute('id', previewImageId);
    previewImage.setAttribute(
      'style',
      'border: 0; ' + (maxHeight ? 'max-height: ' + maxHeight + 'px;' : '')
    );
    previewImage.style.maxWidth = '100%';
    previewImage.crossOrigin = 'anonymous';

    previewImage.onload = previeImageLoadReady;

    previewOverlayId = 'overlayOutput';
    previewOverlay = document.createElement('canvas');
    previewOverlay.setAttribute('id', previewOverlayId);
    previewOverlay.setAttribute(
      'style',
      'border: none;position: absolute; left: 0; top: 0; z-index: 999; border: none;; max-width: 100%; text-align: center;'
    );

    cropperId = 'cropView';
    cropper = document.createElement('div');
    cropper.setAttribute('id', cropperId);
    cropper.setAttribute(
      'style',
      'outline:none !important;position: absolute; left: 0; top: 0; z-index: 1000; width: 100%; height: 100%;'
    );

    if (isMobileBrowser) {
      cropPointSize = 40;
    }
    cropper.appendChild((cropLeftTop = createCropItem('leftTop', 'leftTop')));
    cropper.appendChild((cropLeftBot = createCropItem('leftBot', 'leftBot')));
    cropper.appendChild(
      (cropRightTop = createCropItem('rightTop', 'rightTop'))
    );
    cropper.appendChild(
      (cropRightBot = createCropItem('rightBot', 'rightBot'))
    );

    cropper.appendChild(
      (cropLeft = createCropItem('sideLeft', 'cropPointVertical'))
    );
    cropper.appendChild(
      (cropBot = createCropItem('sideBot', 'cropPointHorisontal'))
    );
    cropper.appendChild(
      (cropRight = createCropItem('sideRight', 'cropPointVertical'))
    );
    cropper.appendChild(
      (cropTop = createCropItem('sideTop', 'cropPointHorisontal'))
    );

    cropper.addEventListener('touchstart', dragCropItemStart, false);
    cropper.addEventListener('touchend', dragCropItemEnd, false);
    cropper.addEventListener('touchmove', dragCropItem, false);

    cropper.addEventListener('mousedown', dragCropItemStart, false);
    cropper.addEventListener('mouseup', dragCropItemEnd, false);
    cropper.addEventListener('mousemove', dragCropItem, false);
    cropper.style.display = 'none';

    zoom = document.createElement('div');
    zoom.setAttribute('id', 'previewZoom');
    zoom.setAttribute(
      'style',
      'display: none; text-align: center; position: absolute; left: 0; top: 0; z-index: 1002; border: 2px solid #fefefe; width: ' +
        zoomSize +
        'px; height: ' +
        zoomSize +
        'px; overflow: hidden; backround-repeat: no-repeat; border-radius: 75px;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);'
    );
    let cross = document.createElement('span');
    cross.innerHTML = '&#10011;';
    cross.style =
      'font-size: 50px; display: block; line-height: ' +
      zoomSize +
      'px; color: #11ff0d; opacity: 0.8;';
    zoom.appendChild(cross);

    resultOutputId = 'resultOutput';
    resultOutput = document.createElement('canvas');
    resultOutput.setAttribute('id', resultOutputId);

    if (previewConainerId) {
      previewContainer.appendChild(previewImage);
      previewContainer.appendChild(previewOverlay);
      previewContainer.appendChild(cropper);
      previewContainer.appendChild(zoom);
      //previewContainer.appendChild(cropResult);
      previewContainer.style.position = 'relative';
    }

    lastShotCanvas = document.createElement('canvas');
    detectCanvas = document.createElement('canvas');
    cropCanvas = document.createElement('canvas');

    /** CSS Mode **/
    cropResultImageWarapper = document.createElement('div');
    cropResultImageContainer = document.createElement('div');
    cropResultImageWarapper.style = 'margin-left: -9999px; position: absolute;';
    //cropResultImageWarapper.style = 'position: absolute;';
    cropResultImageContainer.style = 'overflow: hidden;';
    cropResultImageContainer.appendChild(cropCanvas);
    cropResultImageWarapper.appendChild(cropResultImageContainer);

    document.body.appendChild(cropResultImageWarapper);

    debug = document.createElement('div');
    debug.setAttribute(
      'style',
      'z-index: 10000; position: fixed; left: 0; top: 0; background-color: rgba(0, 0, 0, 0.3); color: #fff'
    );
    //document.body.appendChild(debug);
  };

  this.setPreviewContainer = function(containerId, maxHeight) {
    previewConainerId = containerId;
    previewContainer = document.getElementById(previewConainerId);
    previewContainer.appendChild(previewImage);
    previewContainer.appendChild(previewOverlay);
    previewContainer.appendChild(cropper);
    previewContainer.appendChild(zoom);
    previewContainer.style.position = 'relative';

    previewImage.style.maxHeight = maxHeight ? maxHeight + 'px' : '';
    updatePreviewLayer();
    self.showCropRect();
  };

  /**
   * Create button to load image from desctop or start camera in mobile.
   *
   * @param containerId - container for button
   * @param title - title for button
   */
  this.createLoadButton = function(containerId, title) {
    let loadButton = document.createElement('button');
    loadButton.addEventListener(
      'click',
      function() {
        loadFile.click();
      },
      false
    );
    loadButton.innerText = title ? title : 'Load...';

    let container = document.getElementById(containerId);
    //container.appendChild(loadFile);
    container.appendChild(loadButton);
  };

  /**
   * Return event for load image from desctop or start camera in mobile.
   *
   */
  this.getLoadButtonClickEvent = function() {
    return function() {
      //alert("start load dialog");
      loadFile.click();
    };
  };

  /**
   * Create view for end result.
   *
   * @param containerId
   */
  this.createResultView = function(containerId) {
    resultConainerId = containerId;
    resultConainer = document.getElementById(resultConainerId);

    resultOutput.setAttribute(
      'style',
      'border: none; position: absolute; left: 0; top: 0; z-index: 999; border: none; max-width: 100%; max-height: 100%;'
    );
    resultConainer.appendChild(resultOutput);
  };

  /**
   * Return base64-image url from result canvas.
   *
   * @returns {string}
   */
  this.getResultImageUrl = function() {
    if (cssMode) {
      return window.URL.createObjectURL(self.base64ToBlob(resultURI));
    } else {
      return self.getCanvasBlobURL(resultOutput, resultQuality);
    }
  };

  this.restoreLastUsedImage = function(onDone) {
    if (self.lastUsedImageUrl) {
      self.loadImageToCanvas(self.lastUsedImageUrl, lastShotCanvas, onDone);
    }
  };

  /**
   * Return base64-image url from original canvas.
   *
   * @returns {string}
   */
  this.cacheOriginalImage = function() {
    // White composite before JPEG — transparent PNG pixels must not become black
    self.lastUsedImageUrl = canvasToJpegDataUrl(lastShotCanvas);
  };

  /**
   * Configure style option for crop-rect.
   *
   * @param fillColor - filling color
   * @param strokeColor - color of stroke rectangle
   * @param strokeWidth  - line width of stroke rectangle
   * @param opacity - opacity for rectangle
   */
  this.setRectOptions = function(fillColor, strokeColor, strokeWidth, opacity) {
    rectOptions = {
      opacity: opacity,
      fillColor: fillColor,
      strokeColor: strokeColor,
      strokeWidth: strokeWidth
    };
  };

  function copyPoints(points) {
    return JSON.parse(JSON.stringify(points));
  }

  /**
   * Shows crop rect and crop points on preview image.
   *
   * @param points - if emty, used last defined points, if no points at all, show rect in cententer of preview image
   */
  this.showCropRect = function(points) {
    if (points === undefined) points = lastDetectedPoints;

    if (!points) points = getStartPreviewPoints();

    //cropper.style.display = "block";

    lastDetectedPoints = points;
    scaledDetectedPoints = scalePointsToPreview(points);
    scaledUserPoints = copyPoints(scaledDetectedPoints);

    drawPointsRect(previewOverlay, scaledUserPoints);

    placeCropPoints();
    placeCropPoints();
  };

  /**
   * Draw crop rectangle on canvas from points
   *
   * @param canvas
   * @param points
   * @param alpha
   * @param selfRectOptions
   */
  function drawPointsRect(canvas, points, alpha, selfRectOptions) {
    const useRectOptions = selfRectOptions ? selfRectOptions : rectOptions;
    let ctx = canvas.getContext('2d', { alpha: alpha });
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.globalAlpha = useRectOptions.opacity;
    ctx.fillStyle = useRectOptions.fillColor;
    ctx.strokeStyle = useRectOptions.strokeColor;
    ctx.lineWidth = useRectOptions.strokeWidth;

    ctx.beginPath();
    ctx.moveTo(Math.round(points.leftTop.x), Math.round(points.leftTop.y));
    ctx.lineTo(Math.round(points.rightTop.x), Math.round(points.rightTop.y));
    ctx.lineTo(Math.round(points.rightBot.x), Math.round(points.rightBot.y));
    ctx.lineTo(Math.round(points.leftBot.x), Math.round(points.leftBot.y));
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.globalAlpha = 1.0;
  }

  function getIdCardCropPoins(canvas) {
    // noinspection PointlessBooleanExpressionJS
    const vertical = false && canvas.height > canvas.width;
    const xWidth = vertical ? canvas.height : canvas.width;
    const xHeight = vertical ? canvas.width : canvas.height;

    let oHeight = xHeight - xHeight / 10;
    let oWidth = oHeight * 1.59;
    if (oWidth > xWidth) {
      oWidth = xWidth - xWidth / 10;
      oHeight = xWidth / 1.59;
    }

    const hPad = (xHeight - oHeight) / 2;
    const wPad = (xWidth - oWidth) / 2;

    return {
      leftTop: { x: wPad, y: hPad },
      rightTop: { x: wPad + oWidth, y: hPad },
      leftBot: { x: wPad, y: hPad + oHeight },
      rightBot: { x: wPad + oWidth, y: hPad + oHeight },
      rect: { wPad, hPad, oWidth, oHeight }
    };
  }

  // noinspection JSUnusedLocalSymbols
  function drawIdCardOverlay(canvas) {
    let ctx = canvas.getContext('2d', { alpha: true });
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.globalAlpha = 0.5;
    ctx.fillStyle = 'white';
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2;

    const cropPoints = getIdCardCropPoins(canvas).rect;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.clearRect(
      cropPoints.wPad,
      cropPoints.hPad,
      cropPoints.oWidth,
      cropPoints.oHeight
    );

    ctx.globalAlpha = 1.0;
  }

  function drawSelfieOverlay(canvas) {
    let ctx = canvas.getContext('2d', { alpha: true });
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.globalAlpha = 0.5;
    ctx.fillStyle = 'white';
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.lineWidth = 10;
    ctx.strokeStyle = 'red';
    ctx.arc(150, 75, 50, 0, 2 * Math.PI, false);
    ctx.fill();

    ctx.globalAlpha = 1.0;
  }

  /**
   * Find edges in given canvas.
   *
   * @param canvas - if empty, will be used canvas from last loaded previewImage
   * @param cbk
   * @param doNotCheckArea
   * @param quickFind
   * @param hardAnglesCheck
   *
   * @returns points if edge detected or false
   */
  function findRectPoints(
    canvas,
    cbk,
    doNotCheckArea,
    quickFind,
    hardAnglesCheck
  ) {
    let scaleSize = 1;

    if (!canvas) {
      canvas = detectCanvas;
      if (Math.max(lastShotCanvas.width, lastShotCanvas.height) > detectSize) {
        scaleSize =
          detectSize / Math.max(lastShotCanvas.width, lastShotCanvas.height);
      }
    }

    lastDetectedPoints = false;
    lastCropAreaPercents = 0;
    lastDetectedPointsFailed = true;

    let acceptPoints = points => {
      if (points) {
        let orderedPoints = orderPoints(points);

        if (isAnglesIsOk(orderedPoints, hardAnglesCheck)) {
          orderedPoints = scalePoints(
            orderedPoints,
            1 / scaleSize,
            1 / scaleSize
          );
          if (doNotCheckArea || isPointsAreaOk(orderedPoints)) {
            lastDetectedPoints = orderedPoints;
            lastDetectedPointsFailed = false;
            return true;
          }
        }
      }
      return false;
    };

    let angles = quickFind ? [0] : [0, -15, 15, -30, 30];
    getHoughPoints(canvas, angles, quickFind ? 2 : false, acceptPoints);
    cbk(lastDetectedPoints);
  }

  this.showCropOverlay = () => {
    self.showCrop();
    self.showCropRect();
  };

  /**
   * Find edges in given canvas.
   *
   * @param canvas - if empty, will be used canvas from last loaded previewImage
   * @returns points if edge detected or false
   */
  this.findAndDisplayRectPoints = function(canvas) {
    let doFind = () => {
      findRectPoints(canvas, () => {
        if (lastDetectedPoints) {
          self.showCropOverlay();
        }
        self.hideSpinner();
        if (self.onFindPointsComplete) {
          self.onFindPointsComplete(lastDetectedPoints !== false);
        }
      });
    };
    if (showSpinnerOnProcessingImage) {
      self.showSpinner();
    }
    requestAnimationFrame(doFind);
  };

  this.showDelayedSpinner = function(after) {
    self.showSpinner();
    setTimeout(after, 50);
  };

  this.rotateImage = function(url, onComplete, angle) {
    const img = new Image();
    !angle ? (angle = -90) : null;
    img.onload = function() {
      let tmpCanvas = document.createElement('canvas');
      const ctx = tmpCanvas.getContext('2d');

      // noinspection JSSuspiciousNameCombination
      tmpCanvas.width = img.naturalHeight;
      // noinspection JSSuspiciousNameCombination
      tmpCanvas.height = img.naturalWidth;

      ctx.rotate((angle * Math.PI) / 180);
      ctx.translate(-img.naturalWidth, 0);
      ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);

      onComplete(self.getCanvasBlobURL(tmpCanvas));
      //tmpCanvas.remove();
      tmpCanvas = null;
    };

    img.src = url;
  };

  /**
   * Set preview image.
   *
   * @param from - can be url for image or canvas with image source
   * @param callBack
   */
  this.setPreviewImage = function(from, callBack) {
    previewImage.style.marginLeft = '-9999px';

    let _src =
      typeof from === 'string' || from instanceof String
        ? from
        : from.toDataURL();

    cropper.style.display = 'none';

    previewImage.callBack = callBack;
    previewImage.src = _src;
  };

  function transformPoint(from, to) {
    let A, H, b, h, i, k, k_i, l, lhs, m, ref, rhs;
    console.assert(from.length === (ref = to.length) && ref === 4);
    A = []; // 8x8
    for (i = k = 0; k < 4; i = ++k) {
      A.push([
        from[i].x,
        from[i].y,
        1,
        0,
        0,
        0,
        -from[i].x * to[i].x,
        -from[i].y * to[i].x
      ]);
      A.push([
        0,
        0,
        0,
        from[i].x,
        from[i].y,
        1,
        -from[i].x * to[i].y,
        -from[i].y * to[i].y
      ]);
    }
    b = []; // 8x1
    for (i = l = 0; l < 4; i = ++l) {
      b.push(to[i].x);
      b.push(to[i].y);
    }
    // Solve A * h = b for h
    h = numeric.solve(A, b);
    H = [
      [h[0], h[1], 0, h[2]],
      [h[3], h[4], 0, h[5]],
      [0, 0, 1, 0],
      [h[6], h[7], 0, 1]
    ];
    // Sanity check that H actually maps `from` to `to`
    for (i = m = 0; m < 4; i = ++m) {
      lhs = numeric.dot(H, [from[i].x, from[i].y, 0, 1]);
      k_i = lhs[3];
      rhs = numeric.dot(k_i, [to[i].x, to[i].y, 0, 1]);
      console.assert(
        numeric.norm2(numeric.sub(lhs, rhs)) < 1e-9,
        'Not equal:',
        lhs,
        rhs
      );
    }
    return H;
  }

  function cropAndScalePoints(points, dx, dy, dScale) {
    return {
      leftTop: {
        x: (points.leftTop.x - dx) * dScale,
        y: (points.leftTop.y - dy) * dScale
      },
      rightTop: {
        x: (points.rightTop.x - dx) * dScale,
        y: (points.rightTop.y - dy) * dScale
      },
      leftBot: {
        x: (points.leftBot.x - dx) * dScale,
        y: (points.leftBot.y - dy) * dScale
      },
      rightBot: {
        x: (points.rightBot.x - dx) * dScale,
        y: (points.rightBot.y - dy) * dScale
      }
    };
  }

  function rotateCropPoint90Left(p, w) {
    // noinspection JSSuspiciousNameCombination
    return { x: p.y, y: w - p.x };
  }

  this.rotatePreview = () => {
    let tmpCanvas = document.createElement('canvas');
    let width = lastShotCanvas.width;
    // noinspection JSSuspiciousNameCombination
    tmpCanvas.width = lastShotCanvas.height;
    // noinspection JSSuspiciousNameCombination
    tmpCanvas.height = width;

    let ctx = tmpCanvas.getContext('2d');
    ctx.rotate(-0.5 * Math.PI);
    ctx.translate(-width, 0);
    ctx.drawImage(lastShotCanvas, 0, 0);

    lastDetectedPoints = upScalePreviewPointsTo(
      scaledUserPoints,
      lastShotCanvas.width,
      lastShotCanvas.height
    );

    lastDetectedPoints = {
      rightBot: rotateCropPoint90Left(lastDetectedPoints.leftBot, width),
      leftBot: rotateCropPoint90Left(lastDetectedPoints.leftTop, width),
      leftTop: rotateCropPoint90Left(lastDetectedPoints.rightTop, width),
      rightTop: rotateCropPoint90Left(lastDetectedPoints.rightBot, width)
    };
    if (lastShotCanvas) lastShotCanvas.remove();
    lastShotCanvas = tmpCanvas;

    preparePreviewFromLastShotCanvas(() => {
      self.showCropRect();
    });
  };

  this.checkIfDocument = function(url, onComplete) {
    // in der Schleife wird neben der avg brightness auch gleich varianceNormalized ermittelt.
    const myImgElement = new Image();
    myImgElement.onload = function() {
      let tmpCanvas = document.createElement('canvas');
      tmpCanvas.width = this.naturalWidth;
      tmpCanvas.height = this.naturalHeight;
      let ctx = tmpCanvas.getContext('2d');
      ctx.drawImage(myImgElement, 0, 0, tmpCanvas.width, tmpCanvas.height);

      let w = tmpCanvas.width,
        h = tmpCanvas.height;
      let imgData = ctx.getImageData(0, 0, w, h);
      let rgbaData = imgData.data;

      let grayishHits = [];
      let varianceHits = 0; // low variance = blurred image or not much text -> use together with avg brightness to white balance picture
      let tolerance = 20;
      let pixelCounter = 0; // px+=8 -> nur jeden 2ten Pixel zählen usw.
      let lastHit = 0; // to calculate varianceHits

      for (let px = 0; px < rgbaData.length; px += 16) {
        let r = rgbaData[px];
        let g = rgbaData[px + 1];
        let b = rgbaData[px + 2];
        let colorSumAvg = (r + g + b) / 3;
        pixelCounter++;

        // find grayish colors
        if (
          colorSumAvg > r - tolerance &&
          colorSumAvg < r + tolerance &&
          colorSumAvg > g - tolerance &&
          colorSumAvg < g + tolerance &&
          colorSumAvg > b - tolerance &&
          colorSumAvg < b + tolerance
        ) {
          grayishHits.push(colorSumAvg);

          if (colorSumAvg > lastHit + 25 || colorSumAvg < lastHit - 25) {
            varianceHits++;
          }
          lastHit = colorSumAvg;
        }
      }

      //tmpCanvas.remove();

      varianceNormalized = (varianceHits / pixelCounter) * 1000;
      let sum = grayishHits.reduce(
        (previous, current) => (current += previous)
      );
      averageBrightness = sum / grayishHits.length;

      onComplete(grayishHits.length / pixelCounter > 0.85);
    };
    myImgElement.src = url;
  };

  function improveDocumentColorLevels(imageData, blackAndWhite) {
    let rgbaData = imageData.data;
    let tolerance = 15;
    let brightness = 100;
    let contrast = 100;
    let grayscale = blackAndWhite == true ? 100 : 0;

    if (averageBrightness < 226) {
      brightness =
        averageBrightness < 100
          ? 0.54 * averageBrightness + 230
          : -0.54 * averageBrightness + 202;
      contrast =
        -0.0019 * Math.pow(averageBrightness, 2) +
        0.74 * averageBrightness +
        40;

      if (grayscale !== 100 && contrast > 100) {
        grayscale = 1.15 * contrast - 115; // Farben linear leicht zurückdrehen wenn Kontrast erhöht wird.
      }
    }

    let brightnessIos = brightness / 100;
    let contrastIos = contrast / 100;
    let factor = grayscale / 100;
    let blacksThreshold = averageBrightness * 1.9 - 220; // dynamischer Grenzwert für Schwarzverstärkung

    for (let px = 0; px < rgbaData.length; px += 4) {
      let r = rgbaData[px];
      let g = rgbaData[px + 1];
      let b = rgbaData[px + 2];

      if (r < blacksThreshold) {
        if (
          r > g - tolerance &&
          r < g + tolerance &&
          r > b - tolerance &&
          r < b + tolerance
        ) {
          // darken greyish dark colors
          let pushDarkness = -0.4 * (0.2126 * r + 0.7152 * g + 0.0722 * b) + 64;
          r = r - pushDarkness;
          g = g - pushDarkness;
          b = b - pushDarkness;
        }
      }

      // adjust contrast for whole picture
      r = r * contrastIos - (contrastIos - 1) / 2;
      g = g * contrastIos - (contrastIos - 1) / 2;
      b = b * contrastIos - (contrastIos - 1) / 2;

      // adjust brightness for whole picture
      r = r * brightnessIos;
      g = g * brightnessIos;
      b = b * brightnessIos;

      // adjust saturation with grayscale percentage (->factor)
      let grayColorValue = 0.2126 * r + 0.7152 * g + 0.0722 * b;

      let rDiff =
        r < grayColorValue
          ? (grayColorValue - r) * factor
          : (r - grayColorValue) * factor;
      let gDiff =
        g < grayColorValue
          ? (grayColorValue - g) * factor
          : (g - grayColorValue) * factor;
      let bDiff =
        b < grayColorValue
          ? (grayColorValue - b) * factor
          : (b - grayColorValue) * factor;

      let rNew = r < grayColorValue ? r + rDiff : r - rDiff;
      let gNew = g < grayColorValue ? g + gDiff : g - gDiff;
      let bNew = b < grayColorValue ? b + bDiff : b - bDiff;

      rgbaData[px] = rNew;
      rgbaData[px + 1] = gNew;
      rgbaData[px + 2] = bNew;

      // white balance document -> whiten nearly white colors in document
      if (
        averageBrightness > 99 &&
        grayColorValue > 116 &&
        !(averageBrightness < 190 && varianceNormalized < 45)
      ) {
        let pushBrightness = 0.6 * grayColorValue - 70;
        rgbaData[px] = rgbaData[px] + pushBrightness;
        rgbaData[px + 1] = rgbaData[px + 1] + pushBrightness;
        rgbaData[px + 2] = rgbaData[px + 2] + pushBrightness;
      }
    } // end for
  }

  this.improveImage = function(source, onComplete, blackAndWhite) {
    const img = new Image();
    let imgOnload = function(targetCanvas) {
      let ctx;
      if (!(targetCanvas instanceof HTMLCanvasElement)) {
        targetCanvas = document.createElement('canvas');
        ctx = targetCanvas.getContext('2d');
        targetCanvas.width = this.naturalWidth;
        targetCanvas.height = this.naturalHeight;

        ctx.drawImage(img, 0, 0, targetCanvas.width, targetCanvas.height);
      } else {
        ctx = targetCanvas.getContext('2d');
      }

      let imgData = ctx.getImageData(
        0,
        0,
        targetCanvas.width,
        targetCanvas.height
      );

      improveDocumentColorLevels(imgData, blackAndWhite);
      ctx.putImageData(imgData, 0, 0);
      onComplete(self.getCanvasBlobURL(targetCanvas));
    };

    if (source instanceof HTMLCanvasElement) {
      imgOnload(source);
    } else {
      img.onload = imgOnload;
      img.src = source;
    }
  };

  function getPointsWidthAndHeihght(p) {
    let width = Math.max(
      lineDistance(p.leftTop, p.rightTop),
      lineDistance(p.leftBot, p.rightBot)
    );
    let height = Math.max(
      lineDistance(p.leftTop, p.leftBot),
      lineDistance(p.rightTop, p.rightBot)
    );
    return [width, height];
  }

  /**
   * Crop preview image with last user crop-points and place result image in result view.
   */
  this.cropImage = function(callback) {
    let p = upScalePreviewPointsTo(
      scaledUserPoints,
      lastShotCanvas.width,
      lastShotCanvas.height
    );
    lastDetectedPoints = p;

    let pp = correctPointsPrespective(p);
    let angle =
      (find_angle(pp.leftTop, pp.leftBot, pp.rightBot) +
        find_angle(pp.leftBot, pp.rightBot, pp.rightTop)) /
      2;
    let perspectiveRatio =
      angle > 1.5708 ? 1 : (1 + Math.cos(angle)) * (1 + Math.cos(angle));
    let prespectiveVertical =
      p.leftTop.x === pp.leftTop.x || p.leftTop.x === pp.rightBot.x;

    let newWidth, newHeight;
    [newWidth, newHeight] = getPointsWidthAndHeihght(p);

    //check if need to rotate
    prespectiveVertical
      ? (newHeight *= perspectiveRatio)
      : (newWidth *= perspectiveRatio);

    let cropWidth, cropHeight;
    [cropWidth, cropHeight] = resizeWithAspectRatio(
      newWidth,
      newHeight,
      maxResultSize
    );
    lastCropSize = Math.min(cropWidth, cropHeight);

    //crop original canvas
    let dx = Math.min(p.leftTop.x, p.leftBot.x);
    let dy = Math.min(p.leftTop.y, p.rightTop.y);
    let dxPad = 0; //dx / 4;
    let dyPad = 0; //dy / 3;

    let dWidth = Math.max(p.rightTop.x, p.rightBot.x) - dx + dxPad * 2;
    let dHeight = Math.max(p.leftBot.y, p.rightBot.y) - dy + dyPad * 2;

    let dScale = 1;
    if (Math.max(dWidth, dHeight) > maxResultSize) {
      dScale = maxResultSize / Math.max(dWidth, dHeight);
    }
    let cropCanvasWidth = dWidth * dScale;
    let cropCanvasHeight = dHeight * dScale;

    cropCanvas.width = cropCanvasWidth;
    cropCanvas.height = cropCanvasHeight;
    prespectiveVertical
      ? (cropCanvas.height *= perspectiveRatio)
      : (cropCanvas.width *= perspectiveRatio);

    let tCtx = cropCanvas.getContext('2d');
    tCtx.drawImage(
      lastShotCanvas,
      dx,
      dy,
      dWidth,
      dHeight,
      0,
      0,
      cropCanvasWidth,
      cropCanvasHeight
    );
    p = cropAndScalePoints(p, dx, dy, dScale);

    if (cssMode) {
      //A---C
      //|   |
      //B---D
      let H = transformPoint(
        [p.leftTop, p.leftBot, p.rightTop, p.rightBot],
        [
          { x: 0, y: 0 },
          { x: 0, y: cropHeight },
          { x: cropWidth, y: 0 },
          { x: cropWidth, y: cropHeight }
        ]
      );

      cropCanvas.style.transformOrigin = '0 0';
      cropCanvas.style.transform = `matrix3d(${(function() {
        let k, results;
        results = [];
        for (let i = (k = 0); k < 4; i = ++k) {
          results.push(
            (function() {
              let l, results1;
              results1 = [];
              for (let j = (l = 0); l < 4; j = ++l) {
                results1.push(H[j][i].toFixed(20));
              }
              return results1;
            })()
          );
        }
        return results;
      })().join(',')})`;
      cropResultImageContainer.style.width = cropWidth + 'px';
      cropResultImageContainer.style.height = cropHeight + 'px';

      domtoimage
        .toJpeg(cropResultImageWarapper, {
          quality: resultQuality,
          style: { marginLeft: 0, marginInlineStart: 0, position: 'inherit' }
        })
        .then(function(dataUrl) {
          resultURI = dataUrl;
          if (resultConainer) {
            self.loadImageToCanvas(dataUrl, resultOutput, function() {
              if (callback) callback();
            });
          } else {
            if (callback) callback();
          }
        })
        .catch(function(error) {
          console.error('oops, something went wrong!', error);
        });
    } else {
      require('./glfx');
      // iOs Mode
      canvasfx = fx.canvas();
      const texture = canvasfx.texture(cropCanvas);
      //document.body.appendChild(cropCanvas);
      cropCanvas.style =
        '    top: 0;' +
        '    width: 320px;' +
        '    position: absolute;' +
        '    z-index: 100000;border: 1px solid red';
      //texture.loadContentsOf(element);
      canvasfx
        .draw(texture)
        .perspective(
          [
            p.leftTop.x,
            p.leftTop.y,
            p.rightTop.x,
            p.rightTop.y,
            p.leftBot.x,
            p.leftBot.y,
            p.rightBot.x,
            p.rightBot.y
          ],
          [0, 0, cropWidth, 0, 0, cropHeight, cropWidth, cropHeight]
        )
        .update();

      resultURI = self.getCanvasBlobURL(canvasfx, resultQuality);

      texture.destroy();

      let tCtx = resultOutput.getContext('2d');
      resultOutput.width = cropWidth;
      resultOutput.height = cropHeight;
      tCtx.drawImage(canvasfx, 0, 0);

      if (callback) callback();
    }
  };

  /* ------------------------------------------------------------------------------------ */

  this.mobileAndTabletcheck = function() {
    let check = false;
    (function(a) {
      // noinspection RegExpSingleCharAlternation,RegExpRedundantEscape
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  let dragStartX, dragStartY;

  function dragCropItemStart(e) {
    if (e.target !== e.currentTarget) {
      activeCropping = true;

      e.target.classList.toggle('active');

      // this is the item we are interacting with
      activeCropItem = e.target;

      if (activeCropItem !== null) {
        if (e.type === 'touchstart') {
          dragStartX = e.touches[0].clientX;
          dragStartY = e.touches[0].clientY;
        } else {
          dragStartX = e.clientX;
          dragStartY = e.clientY;
        }
        showZoom(activeCropItem.getAttribute('id'));
        movePreviewPoint(activeCropItem.getAttribute('id'));

        placeCropTranslateMode = true;
      }
    }
    e.preventDefault();
  }

  function dragCropItemEnd(e) {
    e.target.classList.toggle('active');

    activeCropping = false;
    activeCropItem = null;
    zoom.style.display = 'none';

    placeCropTranslateMode = false;
    scaledDetectedPoints = copyPoints(scaledUserPoints);
  }

  function dragCropItem(e) {
    if (activeCropping) {
      let moveX, moveY;

      if (e.type === 'touchmove') {
        e.preventDefault();
        moveX = e.touches[0].clientX - dragStartX;
        moveY = e.touches[0].clientY - dragStartY;

        debug.innerHTML = e.touches[0].clientX + '<br>' + e.touches[0].clientY;
      } else {
        moveX = e.clientX - dragStartX;
        moveY = e.clientY - dragStartY;
      }

      /*let touchSpeed = isMobileBrowser ? 2 : 1;
            touchSpeed = 2;
            if (touchSpeed != 2) {
                let dragSpeed = Math.max(Math.abs(moveX), Math.abs(moveY)) > 6 ? 0 : 1/4;
                moveX -= moveX * dragSpeed;
                moveY -= moveY * dragSpeed;
            }*/

      movePreviewPoint(activeCropItem.getAttribute('id'), moveX, moveY, 1.5);
    }
    e.preventDefault();
  }

  // noinspection JSUnusedLocalSymbols
  function setCropTranslate(xPos, yPos, el, speed) {
    el.style.transform =
      'translate3d(' + xPos / speed + 'px, ' + yPos / speed + 'px, 0)';
  }

  function createCropItem(id, type) {
    let item = document.createElement('div');
    item.setAttribute('id', id);
    item.setAttribute('class', 'cropPoint ' + type);
    item.setAttribute('type', type);

    return item;
  }

  function updatePreviewLayer() {
    previewOverlay.height = previewImage.offsetHeight;
    previewOverlay.width = previewImage.offsetWidth;
    previewOverlay
      .getContext('2d')
      .clearRect(0, 0, previewOverlay.width, previewOverlay.height);

    imageOffsetLeft = previewImage.offsetLeft;
    previewOverlay.style.left = imageOffsetLeft + 'px';
  }

  function previeImageLoadReady() {
    updatePreviewLayer();

    zoom.style.backgroundImage = 'url(' + previewImage.src + ')';
    zoom.style.backgroundRepeat = 'no-repeat';
    zoom.style.backgroundColor = 'black';

    if (previewImage.callBack) {
      previewImage.callBack();
    }
  }

  function setLastShotCanvas(source, width, height, video) {
    const ctx = lastShotCanvas.getContext('2d');

    if (false && video && rectOverlayMode && cssMode) {
      const rect = getIdCardCropPoins(source).rect;
      lastShotCanvas.width = rect.oWidth;
      lastShotCanvas.height = rect.oHeight;

      ctx.drawImage(
        source,
        rect.wPad,
        rect.hPad,
        rect.oWidth,
        rect.oHeight,
        0,
        0,
        lastShotCanvas.width,
        lastShotCanvas.height
      );
    } else {
      lastShotCanvas.width = width;
      lastShotCanvas.height = height;
      ctx.drawImage(source, 0, 0, lastShotCanvas.width, lastShotCanvas.height);
    }

    if (video) {
    } else {
      preparePreviewFromLastShotCanvas(previewImage.callBack);
    }
  }

  function resizeWithAspectRatio(origWidth, origHeight, newSize, upscale) {
    let newWidth = origWidth;
    let newHeight = origHeight;
    if (Math.max(origWidth, newHeight) > newSize || upscale) {
      let scale =
        Math.min(origWidth, origHeight) / Math.max(origWidth, origHeight);
      newWidth = origWidth > origHeight ? newSize : newSize * scale;
      newHeight = origWidth < origHeight ? newSize : newSize * scale;
    }
    return [newWidth, newHeight];
  }

  function prepareDetectCanvas(detectCanvas, sourceCanvas, width, height) {
    let detectWidth, detectHeight;
    [detectWidth, detectHeight] = resizeWithAspectRatio(
      width ? width : sourceCanvas.width,
      height ? height : sourceCanvas.height,
      detectSize
    );

    let ctx = detectCanvas.getContext('2d');
    detectCanvas.width = detectWidth;
    detectCanvas.height = detectHeight;
    ctx.drawImage(sourceCanvas, 0, 0, detectWidth, detectHeight);
  }

  function preparePreviewFromLastShotCanvas(callBack) {
    let previewWidth, previewHeight;
    [previewWidth, previewHeight] = resizeWithAspectRatio(
      lastShotCanvas.width,
      lastShotCanvas.height,
      maxPreviewSize
    );

    let tmpCanvas = document.createElement('canvas');
    let ctx = tmpCanvas.getContext('2d');
    tmpCanvas.width = previewWidth;
    tmpCanvas.height = previewHeight;
    ctx.drawImage(lastShotCanvas, 0, 0, previewWidth, previewHeight);

    prepareDetectCanvas(detectCanvas, tmpCanvas);

    if (previewImage.src) {
      URL.revokeObjectURL(previewImage.src);
    }

    previewImage.callBack = callBack;
    previewImage.src = self.getCanvasBlobURL(lastShotCanvas, 0.5);

    //tmpCanvas.remove();
    tmpCanvas = null;
  }

  this.isLoadedImageTooSmall = minSize => {
    return (
      Math.min(lastShotCanvas.width, lastShotCanvas.height) <
      (minSize ? minSize : minResultSize)
    );
  };

  function getResizeFromLastShotCanvas() {
    let resizeWidth, resizeHeight;
    [resizeWidth, resizeHeight] = resizeWithAspectRatio(
      lastShotCanvas.width,
      lastShotCanvas.height,
      maxResultSize
    );

    let tmpCanvas = document.createElement('canvas');
    const ctx = tmpCanvas.getContext('2d');
    tmpCanvas.width = resizeWidth;
    tmpCanvas.height = resizeHeight;
    ctx.drawImage(lastShotCanvas, 0, 0, resizeWidth, resizeHeight);
    let result = self.getCanvasBlobURL(tmpCanvas, resultQuality);
    //tmpCanvas.remove();
    return result;
  }

  function scalePoints(points, scaleX, scaleY) {
    return {
      rightBot: {
        x: points.rightBot.x * scaleX,
        y: points.rightBot.y * scaleY
      },
      leftBot: { x: points.leftBot.x * scaleX, y: points.leftBot.y * scaleY },
      leftTop: { x: points.leftTop.x * scaleX, y: points.leftTop.y * scaleY },
      rightTop: {
        x: points.rightTop.x * scaleX,
        y: points.rightTop.y * scaleY
      }
    };
  }

  function scalePointsToPreview(points) {
    let scaleX = previewImage.offsetWidth / lastShotCanvas.width;
    let scaleY = previewImage.offsetHeight / lastShotCanvas.height;
    return scalePoints(points, scaleX, scaleY);
  }

  function upScalePreviewPointsToZoom(points) {
    let scaleX = previewImage.naturalWidth / previewImage.width;
    let scaleY = previewImage.naturalHeight / previewImage.height;
    return scalePoints(points, scaleX, scaleY);
  }

  function upScalePreviewPointsTo(points, width, height) {
    let scaleX = width / previewImage.width;
    let scaleY = height / previewImage.height;
    return scalePoints(points, scaleX, scaleY);
  }

  function upScalePointsTo(points, fromWidth, fromHeight, width, height) {
    let scaleX = width / fromWidth;
    let scaleY = height / fromHeight;
    return scalePoints(points, scaleX, scaleY);
  }

  function getStartPreviewPoints() {
    let w = lastShotCanvas.width;
    let h = lastShotCanvas.height;
    let yPad = h / 10;
    let xPad = w / 10;
    let newHeight = h - yPad * 2;
    let newWidth = w - xPad * 2;
    let max = Math.max(newWidth, newHeight);
    let correction =
      Math.max(newWidth, newHeight) / 1.4142 / Math.min(newWidth, newHeight);

    newWidth > newHeight
      ? (newHeight = Math.round(newWidth / 1.4142))
      : (newWidth = Math.round(newHeight / 1.4142));
    if (correction > 1) {
      newWidth /= correction;
      newHeight /= correction;
    }
    return {
      leftTop: { x: w / 2 - newWidth / 2, y: h / 2 - newHeight / 2 },
      rightTop: { x: w / 2 + newWidth / 2, y: h / 2 - newHeight / 2 },
      leftBot: { x: w / 2 - newWidth / 2, y: h / 2 + newHeight / 2 },
      rightBot: { x: w / 2 + newWidth / 2, y: h / 2 + newHeight / 2 }
    };
  }

  function pointTranslation(to, from) {
    return { x: from.x - to.x, y: from.y - to.y };
  }

  function getMiddleCropPoint(p1, p2) {
    return {
      x: Math.min(p1.x, p2.x) + Math.abs(p1.x - p2.x) / 2,
      y: Math.min(p1.y, p2.y) + Math.abs(p1.y - p2.y) / 2
    };
  }

  function getAngle(p1, p2, fix) {
    return p2.y - p1.y === 0
      ? 0
      : (fix ? 90 : 0) -
          (Math.atan((p2.x - p1.x) / (p2.y - p1.y)) * 180) / Math.PI;
  }

  let placeCropTranslateMode = false;
  function placeCropPoints(translate) {
    //debugger;
    translate = placeCropTranslateMode = false;

    let placeLeftTop = translate
      ? pointTranslation(scaledDetectedPoints.leftTop, scaledUserPoints.leftTop)
      : scaledUserPoints.leftTop;
    let placeLeftBot = translate
      ? pointTranslation(scaledDetectedPoints.leftBot, scaledUserPoints.leftBot)
      : scaledUserPoints.leftBot;
    let placeRightTop = translate
      ? pointTranslation(
          scaledDetectedPoints.rightTop,
          scaledUserPoints.rightTop
        )
      : scaledUserPoints.rightTop;
    let placeRightBot = translate
      ? pointTranslation(
          scaledDetectedPoints.rightBot,
          scaledUserPoints.rightBot
        )
      : scaledUserPoints.rightBot;

    const leftLine = lineDistance(placeLeftTop, placeLeftBot);
    const topLine = lineDistance(placeLeftTop, placeRightTop);
    const rightLine = lineDistance(placeRightTop, placeRightBot);
    const botLine = lineDistance(placeLeftBot, placeRightBot);

    placeCropItem(cropLeftTop, placeLeftTop, 0, Math.min(leftLine, topLine));
    placeCropItem(cropRightTop, placeRightTop, 0, Math.min(rightLine, topLine));
    placeCropItem(cropRightBot, placeRightBot, 0, Math.min(rightLine, botLine));
    placeCropItem(cropLeftBot, placeLeftBot, 0, Math.min(leftLine, botLine));

    placeCropItem(
      cropLeft,
      getMiddleCropPoint(placeLeftTop, placeLeftBot),
      getAngle(placeLeftTop, placeLeftBot),
      leftLine
    );
    placeCropItem(
      cropRight,
      getMiddleCropPoint(placeRightTop, placeRightBot),
      getAngle(placeRightTop, placeRightBot),
      rightLine
    );
    placeCropItem(
      cropBot,
      getMiddleCropPoint(placeLeftBot, placeRightBot),
      getAngle(placeLeftBot, placeRightBot, true),
      botLine
    );
    placeCropItem(
      cropTop,
      getMiddleCropPoint(placeLeftTop, placeRightTop),
      getAngle(placeLeftTop, placeRightTop, true),
      topLine
    );
  }

  function placeCropItem(item, point, angle, sideSize) {
    const minDist = 2 * cropPointSize + 30 + 40;
    let borderWidth =
      sideSize < minDist ? (sideSize - 40) / 2 - 10 : cropPointSize + 10;
    borderWidth = Math.round(borderWidth / 10) * 10;

    borderWidth = borderWidth < 10 ? 10 : borderWidth;

    if (placeCropTranslateMode) {
      item.style.transform = '';
      item.style = `border-width: ${borderWidth}px;
        translate3d(${point.x}px, ${point.y}px, 0)`;
    } else {
      let idType = item.getAttribute('type');
      let degX = 0;
      let degY = 0;

      let itemWidth = cropPointSize / 2;
      let itemHeight = cropPointSize / 2;
      switch (idType) {
        case 'cropPointVertical':
          itemWidth = 12;
          itemHeight = 35;
          break;
        case 'cropPointHorisontal':
          itemWidth = 35;
          itemHeight = 12;
          break;
      }
      itemWidth += borderWidth * 2;
      itemHeight += borderWidth * 2;

      if (angle) {
        idType === 'cropPointVertical'
          ? (degX = angle - 0.01)
          : (degY = angle - 0.01);
      }
      item.style = `border-width: ${borderWidth}px;
        transform: rotate(${angle ? angle : 0}deg);
        left: ${imageOffsetLeft + point.x - itemWidth / 2}px;
        top: ${point.y - itemHeight / 2}px;`;
    }
  }

  function showZoom(pointName) {
    if (pointName.indexOf('side') !== -1) return;

    zoom.style.left = '';
    zoom.style.top = '';
    zoom.style.right = '';
    zoom.style.bottom = '';

    if (pointName === 'leftTop') {
      zoom.style.right = 0;
      zoom.style.top = 0;
    }
    if (pointName === 'rightTop') {
      zoom.style.left = 0;
      zoom.style.top = 0;
    }
    if (pointName === 'rightBot') {
      zoom.style.right = 0;
      zoom.style.top = 0;
    }
    if (pointName === 'leftBot') {
      zoom.style.left = 0;
      zoom.style.top = 0;
    }
    zoom.style.display = 'block';
  }

  function movePreviewPoint(pointName, xMove, yMove, speed) {
    if (xMove && yMove) {
      xMove /= speed;
      yMove /= speed;

      let pointNameUse = pointName;

      if (pointName.indexOf('side') !== -1) {
        let opposites = {
          left: 'right',
          right: 'left',
          top: 'Bot',
          bot: 'Top',
          Top: 'Bot',
          Bot: 'Top'
        };

        let side = pointName.slice(4).toLowerCase();
        let side2 = side === 'top' || side === 'bot' ? 'left' : 'top';
        let sidei = opposites[side];
        side = opposites[sidei];
        let side2i = opposites[side2];
        side2 = opposites[side2i];

        let p1, p2, p1i, p2i;
        [p1, p2, p1i, p2i] =
          side === 'left' || side === 'right'
            ? [side + side2, side + side2i, sidei + side2, sidei + side2i]
            : [side2 + side, side2i + side, side2 + sidei, side2i + sidei];

        side === 'left' || side === 'right' ? (yMove = 0) : (xMove = 0);

        let moveP1 = {
          x: scaledDetectedPoints[p1].x + xMove,
          y: scaledDetectedPoints[p1].y + yMove
        };
        let moveP2 = {
          x: scaledDetectedPoints[p2].x + xMove,
          y: scaledDetectedPoints[p2].y + yMove
        };

        let newP1 = lineIntersect(
          [scaledDetectedPoints[p1], scaledDetectedPoints[p1i]],
          [moveP1, moveP2]
        );
        let newP2 = lineIntersect(
          [scaledDetectedPoints[p2], scaledDetectedPoints[p2i]],
          [moveP1, moveP2]
        );

        scaledUserPoints[p1] = newP1;
        scaledUserPoints[p2] = newP2;
      } else {
        scaledUserPoints[pointNameUse].x =
          scaledDetectedPoints[pointNameUse].x + xMove;
        scaledUserPoints[pointNameUse].y =
          scaledDetectedPoints[pointNameUse].y + yMove;
      }

      let cropPad = 1;

      let checkNewXPos = x =>
        x < cropPad
          ? cropPad
          : x > previewImage.clientWidth - cropPad
          ? previewImage.clientWidth - cropPad
          : x;
      let checkNewYPos = y =>
        y < cropPad
          ? cropPad
          : y > previewImage.clientHeight - cropPad
          ? previewImage.clientHeight - cropPad
          : y;

      let checkPoint = p => ({ x: checkNewXPos(p.x), y: checkNewYPos(p.y) });

      scaledUserPoints.leftTop = checkPoint(scaledUserPoints.leftTop);
      scaledUserPoints.leftBot = checkPoint(scaledUserPoints.leftBot);
      scaledUserPoints.rightTop = checkPoint(scaledUserPoints.rightTop);
      scaledUserPoints.rightBot = checkPoint(scaledUserPoints.rightBot);
    }

    drawPointsRect(previewOverlay, scaledUserPoints);

    placeCropPoints(true);

    if (pointName.indexOf('side') === -1) {
      let zoomRes =
        Math.min(previewImage.naturalWidth, previewImage.naturalHeight) / 5;
      let _zoomSize = zoomSize + 2;
      zoomRes < _zoomSize ? (zoomRes = _zoomSize) : null;

      let p = upScalePreviewPointsToZoom(scaledUserPoints);
      let x = p[pointName].x;
      let y = p[pointName].y;

      zoom.style.backgroundPosition =
        -x + _zoomSize / 2 + 'px ' + (-y + _zoomSize / 2) + 'px';
    }
  }

  function getNextPointIdx(idx) {
    return idx > 3 ? idx - 4 : idx;
  }

  function correctPointsPrespective(points) {
    // A----B
    // |    |
    // D----C
    let angles = getPointsAngles(points);
    let A = angles[0];
    let B = angles[1];
    let C = angles[2];
    let D = angles[3];

    let pointsArr = [
      points.leftTop,
      points.rightTop,
      points.rightBot,
      points.leftBot
    ];

    let idx = 0; //"DC";
    let treshold = 0.052;

    //if(B - A > treshold && C - D > treshold) idx = 1; //"AD";
    //if(A - B > treshold && D - C > treshold) idx = 3; //"BC";

    let AB = A + B;
    let BC = B + C;
    let CD = C + D;
    let AD = A + D;
    let sides = new Array();
    sides[CD] = 0;
    sides[AD] = 1;
    sides[BC] = 3;
    sides[AB] = 2;
    let min = Math.min(CD, AD, BC, AB);
    idx = sides[min];
    //console.log("AD: B - A = " + (B - A) + " C - D = " + (C - D));
    //console.log("BC: A - B= " + (A - B) + " D - C = " + (D - C));

    let result = points;
    if (idx > 0) {
      result = {
        leftTop: pointsArr[getNextPointIdx(idx)],
        rightTop: pointsArr[getNextPointIdx(idx + 1)],
        rightBot: pointsArr[getNextPointIdx(idx + 2)],
        leftBot: pointsArr[getNextPointIdx(idx + 3)]
      };
    }
    return result;
  }

  /** ------------------------------- Edge detection --------------------- */

  function lineDistance(point1, point2) {
    let xs = 0;
    let ys = 0;

    xs = point2.x - point1.x;
    xs = xs * xs;

    ys = point2.y - point1.y;
    ys = ys * ys;

    return Math.sqrt(xs + ys);
  }

  function find_angle(A, B, C) {
    const AB = Math.sqrt(Math.pow(B.x - A.x, 2) + Math.pow(B.y - A.y, 2));
    const BC = Math.sqrt(Math.pow(B.x - C.x, 2) + Math.pow(B.y - C.y, 2));
    const AC = Math.sqrt(Math.pow(C.x - A.x, 2) + Math.pow(C.y - A.y, 2));
    return Math.acos((BC * BC + AB * AB - AC * AC) / (2 * BC * AB));
  }

  function getPointsAngles(points) {
    return [
      find_angle(points.rightTop, points.leftTop, points.leftBot), //LT
      find_angle(points.rightBot, points.rightTop, points.leftTop), //RT
      find_angle(points.leftBot, points.rightBot, points.rightTop), //RB
      find_angle(points.leftTop, points.leftBot, points.rightBot) //LB
    ];
  }

  function isAnglesIsOk(points, hardCheck) {
    let angles = getPointsAngles(points);

    for (let i = 0; i < 4; i++) {
      if (angles[i] < 1.0472 || angles[i] > 2.0944) return false;
    }
    let topDiff = Math.abs(angles[0] - angles[1]);
    let botDiff = Math.abs(angles[3] - angles[2]);
    let treshold = hardCheck ? 0.2 : 0.55;

    if (
      topDiff > treshold ||
      botDiff >
        treshold /*|| Math.max(botDiff, topDiff) / Math.min(botDiff, topDiff) > 3*/
    )
      return false;

    return true;
  }

  function orderPoints(points) {
    points.sort(function(a, b) {
      return a.x - b.x;
    });

    let result = {};
    if (points[0].y > points[1].y) {
      result.leftTop = points[1];
      result.leftBot = points[0];
    } else {
      result.leftTop = points[0];
      result.leftBot = points[1];
    }
    if (points[3].y > points[2].y) {
      result.rightTop = points[2];
      result.rightBot = points[3];
    } else {
      result.rightTop = points[3];
      result.rightBot = points[2];
    }
    return result;
  }

  function lineIntersect(line1, line2) {
    let line1StartX = line1[0].x;
    let line1StartY = line1[0].y;
    let line1EndX = line1[1].x;
    let line1EndY = line1[1].y;
    let line2StartX = line2[0].x;
    let line2StartY = line2[0].y;
    let line2EndX = line2[1].x;
    let line2EndY = line2[1].y;

    // if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans
    // for whether line segment 1 or line segment 2 contain the point
    let denominator,
      a,
      b,
      numerator1,
      numerator2,
      result = {
        x: null,
        y: null,
        onLine1: false,
        onLine2: false
      };
    denominator =
      (line2EndY - line2StartY) * (line1EndX - line1StartX) -
      (line2EndX - line2StartX) * (line1EndY - line1StartY);
    if (denominator === 0) {
      return undefined;
    }

    a = line1StartY - line2StartY;
    b = line1StartX - line2StartX;
    numerator1 = (line2EndX - line2StartX) * a - (line2EndY - line2StartY) * b;
    numerator2 = (line1EndX - line1StartX) * a - (line1EndY - line1StartY) * b;
    a = numerator1 / denominator;
    b = numerator2 / denominator;

    // if we cast these lines infinitely in both directions, they intersect here:
    result.x = line1StartX + a * (line1EndX - line1StartX);
    result.y = line1StartY + a * (line1EndY - line1StartY);

    // if line1 is a segment and line2 is infinite, they intersect if:
    if (a > 0 && a < 1) {
      result.onLine1 = true;
    }
    // if line2 is a segment and line1 is infinite, they intersect if:
    if (b > 0 && b < 1) {
      result.onLine2 = true;
    }
    // if line1 and line2 are segments, they intersect if both of the above are true
    return result;
  }

  function isPointsAreaOk(points) {
    // Initialze area
    let area = 0; // Accumulates area in the loop
    let j = 3;
    let X = [
      points.leftTop.x,
      points.rightTop.x,
      points.rightBot.x,
      points.leftBot.x
    ];
    let Y = [
      points.leftTop.y,
      points.rightTop.y,
      points.rightBot.y,
      points.leftBot.y
    ];

    for (let i = 0; i < 4; i++) {
      area = area + (X[j] + X[i]) * (Y[j] - Y[i]);
      j = i; //j is previous vertex to i
    }
    area = Math.abs(area / 2);

    let origArea = lastShotCanvas.width * lastShotCanvas.height;
    let mp = Math.round(origArea / 1000000);
    lastCropAreaPercents = (area * 100) / origArea;

    switch (true) {
      case mp < 6:
        return lastCropAreaPercents > 18;
      case mp === 6:
        return lastCropAreaPercents > 16;
      case mp === 7:
        return lastCropAreaPercents > 14;
      case mp === 8:
        return lastCropAreaPercents > 12;
      case mp > 8:
        return lastCropAreaPercents > 10;
    }
  }

  /** ------------------------ Video ------------------------*/
  let resolution = 'vga'; //window.innerWidth < 960 ? 'qvga' : 'vga';

  // whether streaming video from the camera.
  let streaming = false;

  let video = null;
  let videoInputId = '';
  let videoOverlayId = '';
  let videoOverlay = null;
  let videoConainerId = '';
  let videoContainer = null;
  let stream;
  let onCameraError;
  let frontCamera;
  let videoProcessLayer;
  let videoOutput;
  let videoOutputId;
  let rectOverlayMode = false;

  let videoRequestId;
  let videoOverlayRequestId;

  /**
   * Create camera view for WEBRTC video catching.
   *
   * @param {string} containerId - div for view
   * @param {string} res - video resolution qvga: 320x240, vga: 640x480, svga: 800x600, xvga: 1024x768, hd720: 1280x720, hd1080: 1920x1080, qsxga: 2560x2048, 4kdci: 4096x2160
   * @param {boolean} front
   * @param {boolean} _detectMode
   * @param {function} onCameraErrorFunc
   */
  this.createCamera = function(
    containerId,
    res,
    front,
    _detectMode,
    onCameraErrorFunc
  ) {
    this.resetImageProcessingEvents();

    videoConainerId = containerId;
    videoContainer = document.getElementById(videoConainerId);
    videoContainer.innerHTML = '';
    frontCamera = front;
    onCameraError = onCameraErrorFunc;
    rectOverlayMode = _detectMode;

    if (!video) {
      resolution = res ? res : 'vga';

      videoInputId = 'videoInput';
      video = document.createElement('video');
      video.setAttribute('id', videoInputId);
      video.setAttribute('playsinline', true);
      video.setAttribute(
        'style',
        'position: absolute; margin: 0 auto; left: 0; top: 0; z-index: 999;border: none; max-width: 100%; max-height: 100%; height: auto;'
      );

      videoOverlayId = 'videoOverlay';
      videoOverlay = document.createElement('div');
      videoOverlay.setAttribute('id', videoOverlayId);
      /*videoOverlay.setAttribute(
        'style',
        'position: absolute; left: 0; top: 0; z-index: 999; border: none; min-width: 100%; max-width: 100%; max-height: 100%;'
      );*/

      videoOutputId = 'videoOutput';
      videoOutput = document.createElement('canvas');
      videoOutput.setAttribute('id', videoOutputId);
      videoOutput.setAttribute(
        'style',
        'border: none; max-width: 100%; max-height: 100%;'
      );

      videoProcessLayer = document.createElement('canvas');
    }

    video.setAttribute('class', front ? 'mirrorOutput' : '');
    videoOverlay.setAttribute(
      'class',
      'faceOverlay ' + (front ? 'mirrorOutput' : '')
    );
    videoOutput.setAttribute('class', front ? 'mirrorOutput' : '');

    videoContainer.appendChild(video);
    videoContainer.appendChild(videoOverlay);
    //videoContainer.appendChild(videoOutput);
    videoContainer.style.position = 'relative';
  };

  this.shotCamera = function() {
    if (streaming) {
      setLastShotCanvas(video, video.videoWidth, video.videoHeight, true);
      self.hideCrop();
      return true;
    } else {
      onCameraError && onCameraError();
      return false;
    }
  };

  /**
   * Stop camera working
   */
  this.stopCamera = function() {
    if (streaming) {
      doStopCamera();
      onVideoStopped();
    }
  };

  /**
   * Start camera working (exact resolution cascade — document scan etc.).
   * @param {boolean} forDesktop
   * @param {boolean} ios
   * @param {{ skipSpinner?: boolean, onReady?: function }} [options] - skipSpinner: caller shows its own loading UI
   */
  this.startCamera = function(forDesktop, ios, options) {
    if (!streaming) {
      doStartCamera(
        resolution,
        onVideoStarted,
        videoInputId,
        forDesktop,
        ios,
        options
      );
    }
  };

  /**
   * Start front/selfie camera with ideal constraints — one getUserMedia,
   * browser picks the highest available resolution. Prefer this for selfie.
   * @param {{ skipSpinner?: boolean, onReady?: function }} [options]
   */
  this.startCameraIdeal = function(options) {
    if (!streaming) {
      doStartCameraIdeal(onVideoStarted, options);
    }
  };

  function startVideoProcessing() {
    //videoRequestId = requestAnimationFrame(processVideo);
    //videoOverlayRequestId = requestAnimationFrame(processVideoOverlay);
    //processVideoOverlay();

    const elGap = window.isDesktop ? 10 : 8;
    const elH = video.clientHeight - (video.clientHeight / elGap) * 2;
    const elW = elH / 1.3;
    videoOverlay.style.width = elW + 'px';
    videoOverlay.style.height = elH + 'px';
    videoOverlay.style.marginTop = video.clientHeight / elGap + 'px';
  }

  // noinspection JSUnusedLocalSymbols
  function processVideoOverlay() {
    if (!streaming) return;

    videoOverlay.width = video.videoWidth;
    videoOverlay.height = video.videoHeight;
    if (rectOverlayMode && cssMode) {
      drawIdCardOverlay(videoOverlay, video.videoWidth, video.videoHeight);
    }

    drawSelfieOverlay(videoOverlay, video.videoWidth, video.videoHeight);

    if (rectOverlayMode) {
      videoOverlay.width = video.videoWidth;
      videoOverlay.height = video.videoHeight;

      prepareDetectCanvas(
        videoProcessLayer,
        video,
        video.videoWidth,
        video.videoHeight
      );

      findRectPoints(
        videoProcessLayer,
        points => {
          if (points) {
            lastDetectedPoints = upScalePointsTo(
              points,
              videoProcessLayer.width,
              videoProcessLayer.height,
              video.videoWidth,
              video.videoHeight
            );

            let newWidth, newHeight;
            [newWidth, newHeight] = getPointsWidthAndHeihght(
              lastDetectedPoints
            );
            const toSmall = Math.min(newWidth, newHeight) < minResultSize / 2;

            points = upScalePointsTo(
              points,
              videoProcessLayer.width,
              videoProcessLayer.height,
              videoOverlay.width,
              videoOverlay.height
            );

            drawPointsRect(
              videoOverlay,
              points,
              true,
              toSmall
                ? {
                    ...rectOptions,
                    fillColor: 'red',
                    strokeColor: 'red',
                    opacity: 0.2
                  }
                : rectOptions
            );
          }
          //videoOverlayRequestId = requestAnimationFrame(processVideoOverlay);
          setTimeout(processVideoOverlay, 100);
        },
        true,
        true,
        true
      );
    }
  }

  // noinspection JSUnusedLocalSymbols
  function processVideo() {
    if (!streaming) return;

    let ctx = videoOutput.getContext('2d');
    videoOutput.width = video.videoWidth;
    videoOutput.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, videoOutput.width, videoOutput.height);

    requestAnimationFrame(processVideo);
  }

  function onVideoStarted() {
    height = video.videoHeight;
    width = video.videoWidth;

    video.setAttribute('width', width);
    video.setAttribute('height', height);

    //video.style.maxHeight = height * (video.clientWidth / width) + 'px';

    streaming = true;

    startVideoProcessing();
  }

  function stopVideoProcessing() {}

  function onVideoStopped() {
    if (!streaming) return;
    stopVideoProcessing();
    //videoOverlay.getContext('2d').clearRect(0, 0, width, height);
    streaming = false;
  }

  function onVideoCanPlay() {
    if (self._cameraStartedCallbackDone) {
      return;
    }
    self._cameraStartedCallbackDone = true;
    if (self.onCameraStartedCallback) {
      self.onCameraStartedCallback(self.stream, self.video);
    }
  }

  function notifyCameraUiReady(onReady) {
    if (!onReady || self._cameraUiReadyNotified) {
      return;
    }
    self._cameraUiReadyNotified = true;
    try {
      onReady();
    } catch (e) {
      console.log('onReady error', e);
    }
  }

  function attachCameraStream(astream, callback, skipSpinner, onReady) {
    console.log('Camera successful');
    self._cameraUiReadyNotified = false;
    self._cameraStartedCallbackDone = false;

    // Firefox: local preview autoplay usually requires muted
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', true);

    video.srcObject = astream;
    self.video = video;
    stream = astream;
    self.onCameraStartedCallback = callback;

    const markReady = () => {
      onVideoCanPlay();
      notifyCameraUiReady(onReady);
    };

    video.addEventListener('canplay', markReady, { once: true });
    video.addEventListener('playing', markReady, { once: true });
    video.addEventListener('loadedmetadata', markReady, { once: true });

    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(function() {
          markReady();
        })
        .catch(function(err) {
          console.log('video.play() error', err);
          // Still try to proceed if frames are already available
          if (video.readyState >= 2) {
            markReady();
          }
        });
    } else if (video.readyState >= 2) {
      markReady();
    }

    if (!skipSpinner) {
      self.hideSpinner();
    }
  }

  /**
   * Selfie / front camera: prefer one getUserMedia with ideal resolution.
   * Desktop: no facingMode (Edge/Chrome desktop cams often AbortError with it).
   * After AbortError wait briefly before retry — device may still be releasing.
   */
  function doStartCameraIdeal(callback, options) {
    const skipSpinner = options && options.skipSpinner;
    const onReady = options && options.onReady;
    const cameraNotFoundError = (message, notAllowed) => {
      console.log(message);
      if (!skipSpinner) {
        self.hideSpinner();
      }
      onCameraError && onCameraError(notAllowed);
    };

    if (!navigator || !navigator.mediaDevices) {
      cameraNotFoundError('Camera error. No mediaDevices.');
      return;
    }

    if (!skipSpinner) {
      self.showSpinner();
    }

    const isDesktop = Boolean(window.isDesktop);
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    // High ideal; browser picks closest supported. No facingMode on desktop.
    const primaryConstraints = {
      audio: false,
      video: isDesktop
        ? {
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
        : {
            facingMode: { ideal: 'user' },
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
    };

    const fallbackConstraintsList = isDesktop
      ? [{ audio: false, video: true }]
      : [
          { audio: false, video: { facingMode: 'user' } },
          { audio: false, video: true }
        ];

    const tryConstraints = (constraints, label) => {
      console.log(label, constraints);
      return navigator.mediaDevices.getUserMedia(constraints);
    };

    const tryFallbacks = (startIndex, previousErr) => {
      if (startIndex >= fallbackConstraintsList.length) {
        cameraNotFoundError(
          'Camera Error: ' + previousErr.name + ' ' + previousErr.message,
          previousErr.name === 'NotAllowedError'
        );
        return;
      }

      const waitMs =
        previousErr &&
        (previousErr.name === 'AbortError' ||
          previousErr.name === 'NotReadableError')
          ? 500
          : 0;

      delay(waitMs)
        .then(() =>
          tryConstraints(
            fallbackConstraintsList[startIndex],
            'Ideal camera fallback #' + (startIndex + 1)
          )
        )
        .then(function(astream) {
          attachCameraStream(astream, callback, skipSpinner, onReady);
        })
        .catch(function(fallbackErr) {
          console.log(
            'Ideal fallback Error: ' +
              fallbackErr.name +
              ' ' +
              fallbackErr.message,
            fallbackErr
          );
          if (fallbackErr.name === 'NotAllowedError') {
            cameraNotFoundError(
              'getUserMedia Error: ' +
                fallbackErr.name +
                ' ' +
                fallbackErr.message,
              true
            );
            return;
          }
          tryFallbacks(startIndex + 1, fallbackErr);
        });
    };

    tryConstraints(primaryConstraints, 'Ideal camera mode')
      .then(function(astream) {
        attachCameraStream(astream, callback, skipSpinner, onReady);
      })
      .catch(function(err) {
        console.log(
          'Ideal getUserMedia Error: ' + err.name + ' ' + err.message,
          err
        );

        if (err.name === 'NotAllowedError') {
          cameraNotFoundError(
            'getUserMedia Error: ' + err.name + ' ' + err.message,
            true
          );
          return;
        }

        tryFallbacks(0, err);
      });
  }

  function doStartCamera(
    resolution,
    callback,
    videoId,
    forDesktop,
    ios,
    options
  ) {
    const skipSpinner = options && options.skipSpinner;
    const onReady = options && options.onReady;
    const cameraNotFoundError = (message, notAllowed) => {
      console.log(message);
      if (!skipSpinner) {
        self.hideSpinner();
      }
      onCameraError && onCameraError(notAllowed);
    };

    if (!navigator || !navigator.mediaDevices) {
      cameraNotFoundError('Camera error. No mediaDevices.');
      return;
    }

    if (ios && frontCamera) {
      console.log('Ios camera mode');

      const constraints = {
        audio: false,
        video: {
          facingMode: 'user'
        }
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(astream) {
          attachCameraStream(astream, callback, skipSpinner, onReady);
        })
        .catch(function(err) {
          cameraNotFoundError(
            'Camera Error: ' + err.name + ' ' + err.message,
            err.name === 'NotAllowedError'
          );
          console.log(err);
        });
      return;
    }

    navigator.mediaDevices
      .enumerateDevices()
      .then(function(devices) {
        if (!devices.length) {
          cameraNotFoundError('Error, no devices found.');
          return;
        }
        let constraints = {
          qvga: { width: 320, height: 240 },
          vga: { width: 640, height: 480 },
          svga: { width: 800, height: 600 },
          xvga: { width: 1024, height: 768 },
          hd720: { width: 1280, height: 720 },
          hd1080: { width: 1920, height: 1080 },
          qsxga: { width: 2560, height: 2048 },
          '4kdci': { width: 4096, height: 2160 }
        };

        let resolutions = [
          constraints.hd1080,
          constraints.hd720,
          constraints.xvga,
          constraints.svga,
          constraints.vga,
          true
        ].reverse();

        let resolutionIndex =
          frontCamera && lastUsedResolutionFront !== null
            ? lastUsedResolutionFront
            : lastUsedResolution !== null
            ? lastUsedResolution
            : resolutions.length - (forDesktop ? 3 : 1);

        console.log(resolutionIndex);
        let cameraSuccessful = false;
        let stopSearch = false;
        if (!skipSpinner) {
          self.showSpinner();
        }

        const timeOutPromise = new Promise(function(resolve, reject) {
          console.log('Start timeOutPromise');
          setTimeout(
            () => {
              if (!cameraSuccessful) {
                console.log('TimeOutPromise,  resolve false');
                cameraNotFoundError('Time Out for camera search');
                stopSearch = true;
                resolve(false);
              }
            },
            30000,
            false
          );
        });

        const nextResolution = () => {
          if (resolutionIndex === 0) {
            cameraNotFoundError('No more resolutions to test.');
            return;
          }
          let resolution = resolutions[resolutionIndex];
          let videoConstraint =
            resolution === true
              ? true
              : {
                  width: { exact: resolution.width },
                  height: { exact: resolution.height }
                };

          console.log(resolution);
          console.log('================');
          resolutionIndex--;

          try {
            const useDeviceIdSearching = false;
            const skipAllDevices = forDesktop || videoConstraint === true;
            let deviceIndex = 0;

            const checkNextDevice = () => {
              let cameraDeviceId = false;

              if (!skipAllDevices) {
                if (useDeviceIdSearching) {
                  if (deviceIndex >= devices.length) {
                    console.log('Going to next resolution.');
                    nextResolution();
                    return;
                  }

                  const device = devices[deviceIndex];
                  deviceIndex++;

                  if (device.kind === 'videoinput') {
                    console.log('');
                    console.log(
                      'USE BY DEVICE ID: ' +
                        device.kind +
                        ': ' +
                        device.label +
                        ' ID = ' +
                        device.deviceId
                    );
                    if (device.label.includes(frontCamera ? 'front' : 'back')) {
                      cameraDeviceId = device.deviceId;
                    }
                  } else {
                    checkNextDevice();
                    return;
                  }
                }

                if (cameraDeviceId) {
                  videoConstraint.deviceId = { exact: cameraDeviceId };
                } else {
                  videoConstraint.facingMode = frontCamera
                    ? 'user'
                    : 'environment';

                  console.log(
                    'Try to use facingMode: ' + videoConstraint.facingMode
                  );
                }
              }

              Promise.race([
                navigator.mediaDevices
                  .getUserMedia({
                    audio: false,
                    video: videoConstraint
                  })
                  .then(function(astream) {
                    if (stopSearch) {
                      console.log('Camera successful, but time is out.');
                      return false;
                    } else {
                      cameraSuccessful = true;
                      stopSearch = true;
                      attachCameraStream(
                        astream,
                        callback,
                        skipSpinner,
                        onReady
                      );
                      if (frontCamera) {
                        lastUsedResolutionFront = resolutionIndex + 1;
                      } else {
                        lastUsedResolution = resolutionIndex + 1;
                      }
                      return true;
                    }
                  })
                  .catch(function(err) {
                    if (err.name === 'NotAllowedError') {
                      stopSearch = true;
                      cameraNotFoundError(
                        'getUserMedia Error: ' + err.name + ' ' + err.message,
                        true
                      );
                    } else {
                      console.log(
                        'getUserMedia Error: ' + err.name + ' ' + err.message
                      );
                      console.log(err);
                    }
                    return false;
                  }),
                timeOutPromise
              ]).then(function(result) {
                console.log('Race resolved with: ' + result);

                if (result || stopSearch) return;

                if (skipAllDevices || !useDeviceIdSearching) {
                  console.log(
                    'Error or getUserMedia time out, going to next resolution.'
                  );
                  nextResolution();
                } else {
                  console.log(
                    'Error or getUserMedia time out, going to next device.'
                  );
                  checkNextDevice();
                }
              });
            };
            checkNextDevice();
          } catch (e) {
            cameraNotFoundError('Exception on search camera');
            console.log(e);
          }
        };
        nextResolution();
      })
      .catch(function(err) {
        cameraNotFoundError('Error, no devices found: ');
        console.log(err);
      });
  }

  function doStopCamera() {
    if (video) {
      video.pause();
      video.srcObject = null;
      video.removeEventListener('canplay', onVideoCanPlay);
    }
    if (stream) {
      stream.getVideoTracks()[0].stop();
    }
  }

  /** ------------------------- Files -----------------------*/

  this.dataURItoCanvas = function(dataURI, canvas) {
    let img = atob(dataURI);
    let binimg = [];
    for (let i = 0; i < img.length; i++) {
      binimg.push(img.charCodeAt(i));
    }
    let bytearray = new Uint8Array(binimg);

    // Grab the existing image from canvas
    let ctx = canvas.getContext('2d');
    let width = ctx.canvas.width,
      height = ctx.canvas.height;
    let imgdata = ctx.getImageData(0, 0, width, height);

    // Overwrite it with new data
    for (let i = 8, len = imgdata.data.length; i < len; i++) {
      imgdata.data[i - 8] = bytearray[i];
    }

    // Write it back
    ctx.putImageData(imgdata, 0, 0);
  };

  this.getCanvasBlobURL = function(canvas, compression) {
    // White composite before JPEG — transparent PNG pixels must not become black
    // (affects signature upload and any transparent PNG document scan upload).
    return window.URL.createObjectURL(
      self.base64ToBlob(
        canvasToJpegDataUrl(canvas, compression ? compression : 1)
      )
    );
  };

  this.base64ToBlob = function(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  };

  this.loadImageToCanvas = function(url, canvas, calback) {
    let ctx = canvas.getContext('2d');
    let img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
      URL.revokeObjectURL(url);
      calback ? calback() : null;
    };
    img.src = url;
  };

  this.processLoadedImageToPreview = function() {
    preparePreviewFromLastShotCanvas(function() {
      self.hideSpinner();
      if (self.onImagePreviewComplete) {
        self.onImagePreviewComplete();
      }
    });
  };

  this.processLoadedImageToResize = function() {
    return getResizeFromLastShotCanvas();
  };

  function pdfPageToImage(pdf_doc, page_no, readAll) {
    const PRINT_RESOLUTION = 150;
    const PRINT_UNITS = PRINT_RESOLUTION / 72.0;

    pdf_doc.getPage(page_no).then(function(page) {
      // Get viewport of the page at required scale
      let viewport = page.getViewport({ scale: 1 });

      lastShotCanvas.width = viewport.width * PRINT_UNITS;
      lastShotCanvas.height = viewport.height * PRINT_UNITS;

      viewport = page.getViewport({
        scale: 1,
        rotation: viewport.rotation,
        dontFlip: false
      });

      let renderContext = {
        canvasContext: lastShotCanvas.getContext('2d'),
        viewport: viewport,
        transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
        annotationMode: 2
      };

      let renderTask = page.render(renderContext);
      renderTask.promise.then(async () => {
        if (self.onImageLoadComplete) {
          self.onImageLoadComplete();
        }
        page_no++;
        if (readAll && page_no <= pdf_doc.numPages) {
          pdfPageToImage(pdf_doc, page_no, true);
        } else {
          loadImageFromFiles();
        }
      });
    });
  }

  function loadImageFromPDF(blob_url) {
    const PDFJSUtilsImport = importWithRetry(() => import('./PDFJSUtils'));

    PDFJSUtilsImport().then(result => {
      if (!result) {
        self.hideSpinner();
        return;
      }
      const { PDFJSUtils } = result;

      const loadingTask = PDFJSUtils.prototype.getDocument(blob_url);
      loadingTask.promise
        .then(pdf_doc => {
          if (self.onPDFLoadStart) {
            self.onPDFLoadStart(pdf_doc.numPages);
          }
          pdfPageToImage(pdf_doc, 1, self.allowMultyFies);
        })
        .catch(function(error) {
          console.log(error.message);
        });
    });
  }

  function versionCompare(v1, v2, options) {
    let lexicographical = options && options.lexicographical,
      zeroExtend = options && options.zeroExtend,
      v1parts = v1.split('.'),
      v2parts = v2.split('.');

    function isValidPart(x) {
      return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
    }

    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
    }

    if (zeroExtend) {
      while (v1parts.length < v2parts.length) v1parts.push('0');
      while (v2parts.length < v1parts.length) v2parts.push('0');
    }

    if (!lexicographical) {
      v1parts = v1parts.map(Number);
      v2parts = v2parts.map(Number);
    }

    for (let i = 0; i < v1parts.length; ++i) {
      if (v2parts.length === i) {
        return 1;
      }

      if (v1parts[i] === v2parts[i]) {
        continue;
      } else if (v1parts[i] > v2parts[i]) {
        return 1;
      } else {
        return -1;
      }
    }

    if (v1parts.length !== v2parts.length) {
      return -1;
    }

    return 0;
  }

  function loadImageFromFiles() {
    if (!processFiles.length) {
      if (self.onMultyUploadDone) {
        self.onMultyUploadDone();
      }
    } else {
      let file = processFiles.shift();

      if (file.size === 0) {
        skipedFiles.push(file);
        console.log('Skip file with zero length');
        loadImageFromFiles();
        return;
      }

      if (file.type === 'application/pdf') {
        if (self.allowMultyFies && self.onPDFLoaded) {
          self.onPDFLoaded(file, lastUploadFilesCount);
        }
        let pdf_url = URL.createObjectURL(file);
        loadImageFromPDF(pdf_url);
      } else {
        lastLoadedFileTime = Math.abs(Date.now() - file.lastModified);

        getFileAndOrientation(file, function(file, orient) {
          if (!file) {
            loadImageFromFiles();
            return;
          }

          const version = osVersion ? versionCompare(osVersion, '13.2') : false;
          console.log('Compare ios versions: ' + osVersion + ' ' + version);
          //alert("Compare ios versions: " + osVersion + " " + version);
          if (orient > 0 && version === -1) {
            console.log('Use Megapixel');
            const mpImg = new MegaPixImage(file);
            mpImg.render(lastShotCanvas, { orientation: orient }, () => {
              if (self.onImageLoadComplete) {
                self.onImageLoadComplete();
              }
              loadImageFromFiles();
            });
          } else {
            console.log('Do not Use Megapixel');
            self.loadImageToCanvas(
              URL.createObjectURL(file),
              lastShotCanvas,
              () => {
                if (self.onImageLoadComplete) {
                  self.onImageLoadComplete();
                }
                loadImageFromFiles();
              }
            );
          }
        });
      }
    }
  }

  let processFiles = null;
  let lastUploadFilesCount = 0;
  this.addFileInputHandler = function(inputElement) {
    inputElement.addEventListener('change', e => {
      let filesList = e.target.files;
      skipedFiles = [];

      if (filesList.length > 0) {
        if (self.onImageLoadStart) {
          self.onImageLoadStart(filesList.length);
        }

        if (showSpinnerOnProcessingImage) {
          self.showSpinner();
        }
        self.hideCrop();
        processFiles = [];
        lastUploadFilesCount = filesList.length;
        Array.prototype.push.apply(processFiles, filesList);
        loadImageFromFiles();
      }

      e.target.value = null;
    });
  };

  let skipedFiles = [];

  function getFileAndOrientation(file, callback) {
    const reader = new FileReader();

    reader.readedFile = file;

    reader.onerror = function() {
      skipedFiles.push(this.readedFile);
      console.log(reader.error.message);
      return callback(null, -1);
    };

    reader.onload = function() {
      const readedFile = this.readedFile;
      const view = new DataView(reader.result);

      if (view.getUint16(0, false) !== 0xffd8) {
        return callback(readedFile, -2);
      }

      let length = view.byteLength,
        offset = 2;
      while (offset < length) {
        if (view.getUint16(offset + 2, false) <= 8)
          return callback(readedFile, -1);
        const marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xffe1) {
          if (view.getUint32((offset += 2), false) !== 0x45786966) {
            return callback(readedFile, -1);
          }

          const little = view.getUint16((offset += 6), false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          const tags = view.getUint16(offset, little);
          offset += 2;
          for (let i = 0; i < tags; i++) {
            if (view.getUint16(offset + i * 12, little) === 0x0112) {
              return callback(
                readedFile,
                view.getUint16(offset + i * 12 + 8, little)
              );
            }
          }
        } else if ((marker & 0xff00) !== 0xff00) {
          break;
        } else {
          offset += view.getUint16(offset, false);
        }
      }
      return callback(readedFile, -1);
    };
    reader.readAsArrayBuffer(file);
  }

  this.printError = function(err) {
    if (typeof err === 'undefined') {
      err = '';
    } else if (typeof err === 'number') {
      if (!isNaN(err)) {
        if (typeof cv !== 'undefined') {
          err = 'Exception: ' + cv.exceptionFromPtr(err).msg;
        }
      }
    } else if (typeof err === 'string') {
      let ptr = Number(err.split(' ')[0]);
      if (!isNaN(ptr)) {
        if (typeof cv !== 'undefined') {
          err = 'Exception: ' + cv.exceptionFromPtr(ptr).msg;
        }
      }
    } else if (err instanceof Error) {
      err = err.stack.replace(/\n/g, '<br>');
    }
    console.log(err);
  };
};

if (!window.utils) {
  window['utils'] = new scanUtils();
}
